import React, { useEffect, useState } from "react";
import { TextField, FormHelperText } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { firstUpperCase ,validateEmail,validatePassword} from "./helper.js";
import "./style.css";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import AutoCompleteField from "./AutoCompleteField.js";
import { useDispatch, useSelector } from "react-redux";
import { setUsers } from "../../redux/actions/UserActions.js";
import CustomAutocomplete from "../DynamicForm/Autocomplete.js";
import _Autocomplete from "../DynamicForm/_Autocomplete.js";
import { getAPI } from "../../Global.js";

export const validateField = (value, type, label) => {
  let errorMessage = "";
  if (label) {
    switch (type) {
      case "text":
        if (!value) {
          errorMessage = ` ${label} is required`;
        }
        break;
      case "select":
        if (!value) {
          errorMessage = ` ${label} Please Select Value`;
        }
        break;
      case "simple-select":
        if (!value) {
          errorMessage = ` ${label} Please Select`;
        }
        break;
      case "advance-select":
        if (!value) {
          errorMessage = ` ${label} Please Select`;
        }
        break;
      case "datetime-local":
        if (!value) {
          errorMessage = `${label} Please Select  `;
        }
        break;
      case "checkbox":
        if (!value) {
          errorMessage = `${label} Must be Checked`;
        }
        break;
        case "email":
          if (!value || !validateEmail(value)) {
            errorMessage = `${label} must be a valid email address`;
          }
          break;
        case "password":
          if (!value || !validatePassword(value)) {
            errorMessage = `${label} must be at least 8 characters long`;
          }
          break;
          case "phone":
            if (!value || value.length !== 10) {
              errorMessage = `${label} must be exactly 10 characters`;
            }
            break;
      default:
        if (!value || !value.trim()) {
          errorMessage = `${label} Is Required`;
        }
    }
  }
  return errorMessage;
};

const FormField = (props) => {
  const required = props.field.required;
  const label = firstUpperCase(props.field.label);
  let fieldLabel = required ? (
    <span>
      <b style={{ color: "red" }}>*</b> {label}
    </span>
  ) : (
    label
  );
  const type = props.field.type;
  const varient = props.field.varient;
  const placeholder = props.field.placeholder;
  const isDynamic = props.field.dynamic;
  const hook = props.field.hook;
  const defaultObj = props.defaultObj !== undefined ? props.defaultObj : props.field.defaultObj;
  const dafaultValue = props.field.defaultValue
    ? props.field.defaultValue
    : props.defaultValue;
  const name = props.field.name;

  let optionKey = "";
  let searchApi = "";
  let searchOptionHook = "";

  if (props.field.search) {
    searchApi = props.field.search.api ? props.field.search.api : "";
    // console.log("My Search APu 1", searchApi);
    searchApi = searchApi.length > 0 ? getAPI(searchApi) : "";

    searchOptionHook = props.field.search.label ? props.field.search.label : "";
    optionKey = props.field.search.key ? props.field.search.key : "id";
  }
  const [value, setValue] = useState(dafaultValue);
  const [isChecked, setIsChecked] = useState(dafaultValue);
  const [storageData, setStorageData] = useState([]);

  const [error, setError] = useState(
    props.field.error ? props.field.error : ""
  );
  const [blurred, setBlurred] = useState(false);
  const [simpleSelectOptions, setSimpleSelectOptions] = useState(
    props.field.options
  );

  useEffect(() => {
    const storedData = localStorage.getItem("dynamicField");
    if (storedData) {
      setStorageData(JSON.parse(storedData));
    }
  }, []);

  const updateKey = (name, newKey, newLabel) => {
    const newData = [...storageData];

    const dataIndex = newData.findIndex((item) => item.name === name);

    if (dataIndex !== -1) {
      newData[dataIndex].key = newKey;
      newData[dataIndex].label = newLabel;
    } else {
      newData.push({ name, key: newKey, label: newLabel });
    }

    setStorageData(newData);
    // Update local storage with the new data
    localStorage.setItem("dynamicField", JSON.stringify(newData));
  };

  const changeField = async (e) => {
    if (e != undefined && e != null) {
      updateKey(name, e.key, e.label);
      window.location.reload();
    }
  };

  let handleOnChange = (e) => {
    setValue(e.target.value);
    if (blurred) {
      setError(validateField(e.target.value, type, label));
    }
  };
  const handleChange = () => {
    const newChecked = !isChecked;
    setIsChecked(newChecked);
    if (blurred) {
      setError(validateField(newChecked, type, label));
    }
  };
  const handleaAutocompleteChange = (newValue, inputName) => {
    setValue(newValue);
    if (blurred) {
      setError(validateField(newValue.target.value, type, label));
    }
  };
  const handleBlur = (e) => {
    setBlurred(true);
    setError(validateField(value, type, label));
    setError(
      validateField(type === "checkbox" ? isChecked : value, type, label)
    );

    // Validate the field when blurred
  };

  const handleFocus = () => {
    setBlurred(false);
  };

  const renderError = () => {
    // Check if validation is required for this field
    const isValidationRequired = required || false;

    if (isValidationRequired && error && blurred) {
      return <FormHelperText error>{error}</FormHelperText>;
    }
    return null;
  };

  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  switch (type) {
    case "select":
      return (
        <>
          <CustomAutocomplete
            apiUrl={searchApi}
            displayKey={searchOptionHook}
            valueKey={optionKey}
            inputName={name}
            onValueChange={() => {}}
            variant={varient}
            label={fieldLabel}
            onBlur={handleBlur}
            onFocus={handleFocus}
          />
          {renderError()}
        </>
      );
    case "simple-select":
      return (
        <>
          <_Autocomplete
            apiUrl=""
            displayKey="label"
            valueKey="type"
            inputName={name}
            onValueChange={handleaAutocompleteChange}
            variant={varient}
            label={label}
            defaultObj={defaultObj}
            options={simpleSelectOptions}
            onBlur={handleBlur}
            onFocus={handleFocus}
          />
          {renderError()}
        </>
      );
    case "advance-select":
      return (
        <div style={{ position: "relative" }}>
          <_Autocomplete
            apiUrl={searchApi}
            displayKey={searchOptionHook}
            valueKey={optionKey}
            inputName={name}
            onValueChange={handleaAutocompleteChange}
            variant={varient}
            label={fieldLabel}
            onBlur={handleBlur}
            onFocus={handleFocus}
            defaultObj={defaultObj}
          />
          {renderError()}
        </div>
      );
    case "checkbox":
      return (
        <div onBlur={handleBlur} onFocus={handleFocus}>
          <FormControlLabel
            control={<Checkbox checked={isChecked} onChange={handleChange} name={name} />}
            label={fieldLabel}
          />
          <input type="hidden" name={name} value={isChecked} />
          {renderError()}
        </div>
      );
    case "datetime-local":
      return (
        <div style={{ textAlign: "left" }}>
          <TextField
            name={name}
            label={fieldLabel}
            type={type}
            style={{ width: "100%" }}
            variant={varient}
            placeholder={placeholder}
            value={formatDate(value)}
            onChange={handleOnChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
          />
          {renderError()}
        </div>
      );
      case "hidden":
        return <input hidden="true" name={name} value={value}/>
    default:
      return (
        <div style={{ position: "relative" }}>
          <TextField
            name={name}
            label={fieldLabel}
            type={type}
            style={{ width: "100%" }}
            variant={varient}
            placeholder={placeholder}
            value={value}
            onChange={handleOnChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
          />
          {renderError()}
        </div>
      );
  }
};

export default FormField;
